import {
  ChartAveragePriceWoodaebbangMonthlyResponse,
  ChartAveragePriceWoodaebbangResponse,
  ChartAverageRealTradePriceResponse,
  ChartNaverOfferCountParams,
  ChartOfferFormParams,
  ChartOfferFormResponse,
  ChartRealTradePriceByDateResponse,
  ChartRealTradePriceResponse,
  PriceChartParams,
} from 'types/chart';
import { CommonResponse, get } from './clientAxios';

export async function fetchDailyAverageDanjiPrice(params: PriceChartParams) {
  try {
    const response = await get<
      CommonResponse<ChartAveragePriceWoodaebbangResponse[]>
    >('/api/chart/average-price', {
      params,
    });
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}

export async function fetchMonthlyAverageDanjiPrice(params: PriceChartParams) {
  try {
    const response = await get<
      CommonResponse<ChartAveragePriceWoodaebbangMonthlyResponse[]>
    >('/api/chart/monthly/average-price', {
      params,
    });
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}

export async function fetchAverageRealTradePrice(params: PriceChartParams) {
  try {
    const response = await get<
      CommonResponse<ChartAverageRealTradePriceResponse[]>
    >('/api/chart/average-real-trade-price', {
      params,
    });
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}

export async function fetchRealTradePrice(params: PriceChartParams) {
  try {
    const response = await get<CommonResponse<ChartRealTradePriceResponse[]>>(
      '/api/chart/real-trade-price',
      {
        params,
      },
    );
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}

export async function fetchDailyRealTradePrice(params: PriceChartParams) {
  try {
    const response = await get<
      CommonResponse<ChartRealTradePriceByDateResponse[]>
    >('/api/chart/daily/real-trade-price', {
      params,
    });
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}

export async function getChartOfferForm(params: ChartOfferFormParams) {
  const url = '/api/chart/offer-form';
  try {
    const response = await get<CommonResponse<ChartOfferFormResponse[]>>(url, {
      params,
    });
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}

export async function fetchChartNaverOfferCount(
  params: ChartNaverOfferCountParams,
) {
  const url = '/api/chart/naver-offer-count';
  try {
    const response = await get<CommonResponse<ChartOfferFormResponse[]>>(url, {
      params,
    });
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}
